import Responsive from './Responsive';
const r = new Responsive();

class ToTop{
	constructor(target,fixer,speed) {
		this.target = target;
		this.fixer = fixer;
		this.speed = speed;
	}

	exec(){
		const [target,fixer,speed] = [this.target,this.fixer,this.speed];

		$(window).on('load scroll',function(){
			if($(this).scrollTop() > fixer){
				$(target).addClass('active');
			}else{
				$(target).removeClass('active');
			}

			let scrollHeight = $(document).height();
			let scrollPosition = $(this).height() + $(this).scrollTop();
			let aside_footer_h = $('.aside_footer').innerHeight();
			let footer_h = $('.footer').innerHeight();
			let position_fixer;
			let fixed_position;
			if(!r.state()()){
				position_fixer = 0;
				fixed_position = '20px';
			}else{
				position_fixer = 0;
				fixed_position = '25px';
			}

			if ( scrollHeight - scrollPosition  <= (aside_footer_h + footer_h + position_fixer) ) {
				$(target).css({
					'position':'absolute',
					'bottom': '20px'
				});
			} else {
				$(target).css({
					'position':'fixed',
					'bottom': '25px'
				});
			}
		});
	}
}
module.exports = ToTop;



// WEBPACK FOOTER //
// ./dev/js/scripts/ToTop.js